import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import Icon from "@icon/Icon";
/**
 * @export
 * A component that renders a chevron icon to indicate dropdown state, rotating when open.
 *
 * @example
 * ```
 * <DropdownIndicator isOpen={false} />
 * ```
 *
 * @example
 * ```
 * <DropdownIndicator
 *   isOpen={true}
 *   className="custom-indicator"
 *   styles={{ fontSize: '12px', color: '#333' }}
 * />
 * ```
 *
 * @category Overlays
 */
const DropdownIndicator = ({ isOpen, styles, className }) => {
    return _jsx("div", { className: classNames("uxpcore_dropdown_indicator__container", className, {
            "uxpcore_dropdown_indicator__container--open": isOpen
        }), style: styles, children: _jsx(Icon, { icon: ['phl', 'caret-down'] }) });
};
export default DropdownIndicator;
